import React, { useState } from 'react';
import { sendEmail } from '../services/emailService';

const INITIAL_FORM = {
  name: '',
  company: '',
  email: '',
  phone: '',
  plan: 'Plano Start',
  monthlyVolume: 'Até 5.000 mensagens por mês',
  message: '',
  acceptedTerms: false,
};

export default function WhatsAppLeadForm() {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const onFieldChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus(null);

    const payload = {
      to: 'emerson.farias@esdevcode.com.br',
      subject: `Lead WhatsApp API Oficial - ${formData.name}`,
      body: [
        'Novo lead recebido pelo hotsite /whatsapp',
        '',
        `Nome: ${formData.name}`,
        `Empresa: ${formData.company || 'Não informado'}`,
        `Email: ${formData.email}`,
        `Telefone/WhatsApp: ${formData.phone}`,
        `Plano de interesse: ${formData.plan}`,
        `Volume mensal estimado: ${formData.monthlyVolume}`,
        '',
        'Mensagem:',
        formData.message || 'Sem mensagem adicional.',
      ].join('\n'),
    };

    try {
      await sendEmail(payload);
      setStatus({
        type: 'success',
        message:
          'Recebemos seus dados. Em breve enviaremos a proposta ideal para sua operação.',
      });
      setFormData(INITIAL_FORM);
    } catch (error) {
      setStatus({
        type: 'error',
        message:
          error.message ||
          'Não foi possível enviar agora. Tente novamente em instantes.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="wec-form" onSubmit={onSubmit}>
      <div className="wec-field">
        <label htmlFor="name">Nome completo</label>
        <input
          id="name"
          name="name"
          type="text"
          placeholder="Seu nome"
          value={formData.name}
          onChange={onFieldChange}
          required
        />
      </div>

      <div className="wec-field">
        <label htmlFor="company">Empresa</label>
        <input
          id="company"
          name="company"
          type="text"
          placeholder="Nome da empresa"
          value={formData.company}
          onChange={onFieldChange}
        />
      </div>

      <div className="wec-field-grid">
        <div className="wec-field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="voce@empresa.com"
            value={formData.email}
            onChange={onFieldChange}
            required
          />
        </div>
        <div className="wec-field">
          <label htmlFor="phone">Telefone / WhatsApp</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            placeholder="(83) 9 9999-9999"
            value={formData.phone}
            onChange={onFieldChange}
            required
          />
        </div>
      </div>

      <div className="wec-field-grid">
        <div className="wec-field">
          <label htmlFor="plan">Plano de interesse</label>
          <select
            id="plan"
            name="plan"
            value={formData.plan}
            onChange={onFieldChange}
            required
          >
            <option>Plano Start</option>
            <option>Plano Growth</option>
            <option>Plano Scale</option>
            <option>Preciso de proposta personalizada</option>
          </select>
        </div>

        <div className="wec-field">
          <label htmlFor="monthlyVolume">Volume mensal estimado</label>
          <select
            id="monthlyVolume"
            name="monthlyVolume"
            value={formData.monthlyVolume}
            onChange={onFieldChange}
            required
          >
            <option>Até 5.000 mensagens por mês</option>
            <option>De 5.001 até 20.000 mensagens por mês</option>
            <option>De 20.001 até 100.000 mensagens por mês</option>
            <option>Acima de 100.000 mensagens por mês</option>
          </select>
        </div>
      </div>

      <div className="wec-field">
        <label htmlFor="message">Objetivo com a API do WhatsApp</label>
        <textarea
          id="message"
          name="message"
          rows={4}
          placeholder="Ex.: enviar lembretes automáticos, campanhas, cobrança e atendimento com chatbot + humano."
          value={formData.message}
          onChange={onFieldChange}
        />
      </div>

      <label className="wec-consent" htmlFor="acceptedTerms">
        <input
          id="acceptedTerms"
          name="acceptedTerms"
          type="checkbox"
          checked={formData.acceptedTerms}
          onChange={onFieldChange}
          required
        />
        Concordo com a Política de Privacidade e com os Termos de Serviço.
      </label>

      {status && (
        <p
          className={`wec-form-status ${
            status.type === 'success' ? 'success' : 'error'
          }`}
          role="status"
        >
          {status.message}
        </p>
      )}

      <button className="wec-btn wec-btn-primary wec-btn-block" type="submit">
        {loading ? 'Enviando proposta...' : 'Quero minha proposta agora'}
      </button>
    </form>
  );
}
